import { UnpagedListResource, createApiResource } from '../apiResourceFactory';
import { API } from '../apiService';
import { AppointmentWindowQueryParams, AppointmentWindowListDTO } from '../apiTypes.shim';

interface AppointmentWindowResource
  extends UnpagedListResource<AppointmentWindowListDTO, AppointmentWindowQueryParams> {}

export const createAppointmentWindowResource = (): AppointmentWindowResource => {
  const appointmentWindowResourceUri = `appointment-window`;

  const { useUnpagedList, unpagedList, unpagedListQueryKey } = createApiResource(API, appointmentWindowResourceUri);
  return { useUnpagedList, unpagedList, unpagedListQueryKey };
};
